// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"183":"cfafc594","448":"3f666248"}[chunkId] + ".css";
};